'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaShoppingBasket = function FaShoppingBasket(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm37.3 17.5q1 0 1.7 0.7t0.8 1.8-0.8 1.8-1.7 0.7h-0.3l-2.3 12.8q-0.1 0.9-0.8 1.5t-1.6 0.6h-24.8q-0.9 0-1.6-0.6t-0.9-1.5l-2.2-12.8h-0.3q-1 0-1.8-0.7t-0.7-1.8 0.7-1.8 1.8-0.7h34.8z m-27.9 15.5q0.5 0 0.9-0.4t0.3-0.9l-0.7-8.1q0-0.5-0.4-0.8t-0.9-0.3-0.8 0.4-0.3 0.9l0.6 8.1q0 0.5 0.4 0.8t0.8 0.3h0.1z m8-1.2v-8.1q0-0.5-0.4-0.8t-0.9-0.4-0.8 0.4-0.4 0.8v8.1q0 0.5 0.4 0.9t0.8 0.3 0.9-0.3 0.4-0.9z m7.4 0v-8.1q0-0.5-0.3-0.8t-0.9-0.4-0.9 0.4-0.3 0.8v8.1q0 0.5 0.3 0.9t0.9 0.3 0.9-0.3 0.3-0.9z m6.9 0.1l0.6-8.1q0-0.5-0.3-0.9t-0.8-0.4-1 0.3-0.4 0.8l-0.6 8.1q0 0.5 0.3 0.9t0.8 0.4h0.1q0.5 0 0.9-0.3t0.4-0.8z m-22.5-23.6l-1.8 8h-2.5l1.9-8.6q0.4-1.7 1.8-2.8t3.1-1.1h3.2q0-0.5 0.4-0.8t0.8-0.4h7.5q0.5 0 0.9 0.4t0.3 0.9h3.3q1.7 0 3.1 1t1.7 2.8l2 8.6h-2.6l-1.8-8q-0.2-0.9-0.9-1.4t-1.5-0.6h-3.3q0 0.5-0.3 0.9t-0.9 0.4h-7.5q-0.5 0-0.8-0.4t-0.4-0.9h-3.2q-0.9 0-1.6 0.6t-0.9 1.4z' })
        )
    );
};

exports.default = FaShoppingBasket;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/shopping-basket.js
// module id = 1056
// module chunks = 168707334958949